import React from "react";
import { useSelector } from "react-redux";
import Widget from "../../../features/widget/Widget";
import realisticIsraelImg from "../../../../../assests/realisticIsrael/realisticIsraelImg.png"
import pathRouts from "../../../../enums/pathRoute";
import classes from "./RealisticIsraelWidget.module.css";

const RealisticIsraelWidget = () => {

    const { texts } = useSelector(state => state.translate);
    
    return (
        <Widget
            color="#06094c"
            width={250}
            height={250}
            className={classes.RealisticIsraelWidget}
            mainLink={`/${pathRouts.REALISTICISRAEL}`}
            titleColor="#FFF"
            contentScrollable={false}
        >
            <div className={classes.WidgetContent}>
                <img
                    src={realisticIsraelImg}
                    alt={texts.realisticIsrael}
                    className={classes.RealisticIsraelImg}
                />
            </div>
        </Widget>
    );
};

export default RealisticIsraelWidget;
